import {useState} from "react";
import React from "react";
import icons from "../helpers/icons";
import {extractDateAndMonth, extractYear} from '../helpers/util';
import VismerKnappen from "../components/VismerKnappen";

const ProeveResultater = (props) => {

    const resultater = [ ...props.resultater ] || [];

    const [resultaterVises, setResultaterVises] = useState(5)

    const rows = resultater
        .map((resultat) => (
            <Resultat key={resultat.id} resultat={resultat} />
        )).splice(0, resultaterVises);



    return (
        <div className="dogweb-prover">
            {rows}
            {resultater.length === 0 &&
                <div>&nbsp;</div>
            }
            <VismerKnappen
                total={resultater.length}
                maxStep="5"
                renderedAmount={resultaterVises}
                incrementer={setResultaterVises}
            />
        </div>
    );
};

const Resultat = (props) => {
    const resultat = props.resultat;
    const [showDetaljer, setShowDetaljer] = useState(false);
    const [showKritikk, setShowKritikk] = useState(false);

    const toggleKritikk = () => {
        if (showKritikk) {
            setShowKritikk(false);
        }else {
            setShowKritikk(true);
        }
    };

    function bedommelseDato(){
        if (resultat.fra !== null) return resultat.fra;
        else if (resultat.til !== null) return resultat.til;
        return null;
    }


    const toggleDetaljer = () => {setShowDetaljer(!showDetaljer)};

    const tittel = () => {
        if (resultat.tittel !== null) {
            return (
                <li><span>Opnået titel:</span> {resultat.tittel}</li>
            );
        } else {
            return null;
        }
    };

    const scoreClip = () => {

        if (resultat.resultatStreng !== null) {
            return (
                <div className="score clip">
                    <span>
                        <img className="icon" src={icons.score} alt="" />
                    </span>
                    { resultat.resultatStreng }
                </div>
            );
        } else {
            return null;
        }
    };


    const detaljer = (
        <div className="line-info" >
            <div className="splitt-line"></div>
            <ul className="dogweb-details">
                <li><span>Prøvetype:</span> {resultat.proevetype}</li>
                <li><span>Klasse:</span> {resultat.klasse}</li>
                <li><span>Sted:</span> {resultat.sted}</li>
                { resultat.dommerStreng !== null &&
                    <li><span>Dommer:</span> {resultat.dommerStreng}</li>
                }
                { tittel() }

                { resultat.utvidetResultatStreng !== null &&
                    <li>
                        {resultat.utvidetResultatStreng}
                    </li>
                }
                { resultat.dokumentUrl !== null &&
                    <li>
                        <a href={resultat.dokumentUrl} className="document-link" rel="noopener noreferrer" target="_blank">{resultat.dokumentNavn}</a>
                    </li>
                }



                { resultat.kritikk !== null &&
                    <li>
                        <button onClick={toggleKritikk} className="kritikk-button">Se kritik</button>
                        {
                            showKritikk &&
                                <div>
                                    <span>{resultat.kritikk}</span>
                                    { resultat.pdfKritikkUrl !== null &&
                                        <span>
                                            <br/>
                                            <a href={resultat.pdfKritikkUrl} className="document-link" rel="noopener noreferrer" target="_blank">PDF Kritik</a>
                                        </span>
                                    }
                                </div>
                        }
                    </li>
                }
                <li><a href={resultat.resultatUrl} className="document-link" rel="noopener noreferrer" target="_blank">Se prøvens resultater</a></li>



            </ul>
        </div>

    );

    return (
        <div>
            <button onClick={toggleDetaljer} className="line">
                <div className="place">
                    <div className="date">{extractDateAndMonth(bedommelseDato())}</div>
                    <div className="location clip">{resultat.proevetype}</div>
                    { scoreClip() }
                </div>
                <div className="club">
                    <div className="year">{extractYear(bedommelseDato())}</div>
                    <div className="club-name clip">{resultat.arrangoerNavn}</div>
                    <div className="arrow">
                        <img className="icon" src={icons.acd} alt="" data-open={showDetaljer}/>
                    </div>
                </div>
            </button>
            { showDetaljer && detaljer}
        </div>
    );

};

export default ProeveResultater;
